import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  collections: {},
  formTypes: [],
  companies: [],
  requesting: true,
  filtersLoading: false,

  isDeleted: false,
  deleting: false,

  isApproved: false,
  approving: false,

  isRejected: false,
  rejecting: false,

  errors: {}
};

const Slice = createSlice({
  name: '@admin/Reports|List',
  initialState,
  reducers: {
    
    getList: (state) => {
        state.collections = {};
        state.requesting = true;
    },
    getListSuccess: (state, action) => {
        const { payload } = action;
        state.collections = payload;
        state.requesting = false;
    },
    getListFailed: (state, action) => {
        state.errors = action.payload;
        state.requesting = false;
    },

  // ----- GET FILTERS ----- 
    getFormFilters: (state) => {
        state.filtersLoading = true;
    },
    getFormFiltersSuccess: (state, action) => {
        const { payload } = action;
        state.formTypes = payload.formTypes || [];
        state.companies = payload.companies || [];
        state.filtersLoading = false;
    },
    getFormFiltersFailed: (state, action) => {
        state.errors = action.payload;
        state.filtersLoading = false;
    },

  // ----- DELETE ----- 
    toDelete: (state) => {
        state.isDeleted = false;
        state.deleting = true;
    },
    toDeleteSuccess: (state) => {
        state.isDeleted = true;
        state.deleting = false;
    },
    toDeleteFailed: (state, action) => {
        state.errors = action.payload;
        state.deleting  = false;
        state.isDeleted = false;
    },

  // ----- APPROVE ----- 
    toApprove: (state) => {
        state.isApproved = false;
        state.approving = true;
    },
    toApproveSuccess: (state) => {
        state.isApproved = true;
        state.approving = false;
    },
    toApproveFailed: (state, action) => {
        state.errors = action.payload;
        state.approving  = false;
        state.isApproved = false;
    },

  // ----- REJECT ----- 
    toReject: (state) => {
        state.isRejected = false;
        state.rejecting = true;
    },
    toRejectSuccess: (state) => {
        state.isRejected = true;
        state.rejecting = false;
    },
    toRejectFailed: (state, action) => {
        state.errors = action.payload;
        state.rejecting  = false;
        state.isRejected = false;
    },
    
  },
});

export const Actions = Slice.actions;

const Reducers = {
  AdminReportsListReducers: Slice.reducer,
}
export default Reducers;
